var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12MonthWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.386,17.216h-.008l-25.771-.261a.75.75,0,0,1-.742-.75V12.15a.75.75,0,0,1,.335-.625l4.16-2.766,4.914-5.1a.75.75,0,0,1,.54-.23H91.736a.75.75,0,0,1,.612.317L96,8.905a.75.75,0,0,1,.138.433v7.127a.75.75,0,0,1-.75.75ZM70.364,15.463l24.271.246V9.577L91.348,4.931H79.132l-4.75,4.928a.751.751,0,0,1-.125.1l-3.893,2.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.842,9.339"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.979,
    cy: 2.979,
    r: 2.979,
    transform: "translate(73.896 13.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.979-.75A3.729,3.729,0,1,1-.75,2.979,3.734,3.734,0,0,1,2.979-.75Zm0,5.959A2.229,2.229,0,1,0,.75,2.979,2.232,2.232,0,0,0,2.979,5.209Z",
    transform: "translate(73.896 13.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.979,
    cy: 2.979,
    r: 2.979,
    transform: "translate(86.262 13.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.979-.75A3.729,3.729,0,1,1-.75,2.979,3.734,3.734,0,0,1,2.979-.75Zm0,5.959A2.229,2.229,0,1,0,.75,2.979,2.232,2.232,0,0,0,2.979,5.209Z",
    transform: "translate(86.262 13.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.293,10.089H73.842v-1.5h10.7V4.516h1.5V9.339A.75.75,0,0,1,85.293,10.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.386,10.089H88.123a.75.75,0,0,1-.75-.75V4.516h1.5V8.589h6.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.521,16.345a6.7,6.7,0,1,0,8.415,4.362A6.7,6.7,0,0,0,75.521,16.345ZM78.89,26.968a4.442,4.442,0,1,1,2.891-5.578A4.441,4.441,0,0,1,78.89,26.968Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.549,14.53h0a8.214,8.214,0,1,1-2.481.386A8.162,8.162,0,0,1,77.549,14.53Zm0,11.148a2.944,2.944,0,1,0-2.8-2.055A2.943,2.943,0,0,0,77.546,25.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.549,15.28h0a7.464,7.464,0,1,1-2.255.35A7.416,7.416,0,0,1,77.549,15.28Zm0,13.408a5.954,5.954,0,0,0,0-11.908h0a5.954,5.954,0,0,0,0,11.908Zm0-11.148a5.2,5.2,0,1,1-1.571.244A5.166,5.166,0,0,1,77.548,17.54Zm0,8.887a3.694,3.694,0,1,0-3.518-2.578A3.692,3.692,0,0,0,77.546,26.427Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 2.67,
    y1: 1.384,
    transform: "translate(82.928 26.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.325,2.05-.345.666.345-.666,3.015.718Z",
    transform: "translate(82.928 26.729)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 2.717,
    y2: 1.409,
    transform: "translate(84 24.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.372,2.074-.345.666.345-.666,3.062.743Z",
    transform: "translate(84 24.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M92.2,32.872a2.708,2.708,0,0,1-1.243-.3l-6.046-3.134a.75.75,0,0,1-.321-1.011l1.8-3.468a.75.75,0,0,1,1.011-.321l6.047,3.134a2.7,2.7,0,0,1-1.246,5.1Zm-5.933-4.425,5.381,2.789a1.187,1.187,0,0,0,.552.136,1.2,1.2,0,0,0,.556-2.272l-5.381-2.789Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12MonthWh);
export default __webpack_public_path__ + "static/media/icon_12month_wh.993721fd7a166b0fb56c859228b281de.svg";
export { ForwardRef as ReactComponent };